import CoordinatePanelRenderer from "./CoordinatePanelRenderer";
import { Coord, GridConfig } from "../../../../../../../../src/types/Interface";
import getLineCoords from "./helpers/getCoordLineCoords";


export default class CoordinatePanelManager {
  private CoordinatePanelRenderer!: CoordinatePanelRenderer;
  private originPoint: Coord = { x: -1, y: -1 };

  constructor(private GridConfig: GridConfig) {
    this.CoordinatePanelRenderer = new CoordinatePanelRenderer(this.GridConfig)
  }
  draw(originPoint: Coord) {
    if (!originPoint || this.originPoint.x == originPoint.x && this.originPoint.y == originPoint.y) { return }
    this.originPoint = originPoint;

    const lineCoords = getLineCoords(this.GridConfig, originPoint);
    this.CoordinatePanelRenderer.reset();
    this.CoordinatePanelRenderer.setNumbers(lineCoords);
    this.CoordinatePanelRenderer.drawLines(lineCoords);
    this.CoordinatePanelRenderer.drawCircle(lineCoords.originCoord);
  }
}